// ThemedBgElement.jsx - Reusable background element for theme-based colors (e.g., progress bar, buttons)
import React from "react";

const ThemedBgElement = ({
  theme,
  children,
  baseClass = "",
  pinkClass = "bg-pink-secondary-500",
  blueClass = "bg-blue-primary-500",
  rounded = false,
}) => {
  const bgClass = theme === "pink" ? pinkClass : blueClass;
  const roundedClass = rounded ? "rounded-full" : "";

  return (
    <div className={`${baseClass} ${bgClass} ${roundedClass}`}>{children}</div>
  );
};

export default ThemedBgElement;